export enum PreflightJoinSteps {
    Camera,
    Speaker,
    Microphone,
    ReadyToJoin,
}
